import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import NewUpdates from './components/NewUpdates';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '韩漫在线观看 - 免费漫画下拉式阅读 - 韩漫漫画网站';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <NewUpdates />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫在线观看',
            url: 'https://www.hanmancomic.com',
            description: '韩漫漫画网站提供稳定服务，支持韩漫在线观看与免费漫画下拉式阅读。',
            sameAs: [],
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫在线观看',
            url: 'https://www.hanmancomic.com',
            description: '韩漫漫画网站提供稳定服务，通过漫画网址支持韩漫在线观看与免费漫画下拉式阅读。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.hanmancomic.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫在线观看 - 首页',
            description: '韩漫在线观看首页，提供免费漫画下拉式阅读服务，浏览热门推荐和最新更新的韩漫作品。',
            url: 'https://www.hanmancomic.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫在线观看',
              url: 'https://www.hanmancomic.com',
            },
            primaryImageOfPage: {
              '@type': 'ImageObject',
              url: 'https://www.hanmancomic.com/hero-image.jpg',
            },
          }),
        }}
      />

      {/* FAQPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '韩漫在线观看需要付费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全不需要！韩漫在线观看致力于提供免费的漫画下拉式阅读服务。您可以通过我们的漫画网址直接访问所有韩漫资源，无需注册、无需付费，即可享受流畅的阅读体验。',
                },
              },
              {
                '@type': 'Question',
                name: '什么是下拉式阅读？如何使用？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '下拉式阅读是一种创新的漫画阅读方式，您只需要在页面上向下滚动即可连续阅读漫画内容，无需点击翻页按钮。',
                },
              },
              {
                '@type': 'Question',
                name: '网站上的韩漫资源多久更新一次？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的漫画网站每天都会更新最新的韩漫章节和资源。热门连载作品通常会在原版发布后的24小时内完成同步更新。',
                },
              },
              {
                '@type': 'Question',
                name: '支持哪些设备阅读？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '韩漫在线观看采用了响应式设计，完美适配电脑、平板和手机等各种设备。',
                },
              },
              {
                '@type': 'Question',
                name: '如何找到我想看的漫画？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过多种方式找到心仪的漫画：使用顶部的分类导航按类型浏览；在首页"热门推荐"中查看人气作品；在"最新更新"中关注最近更新的漫画。',
                },
              },
              {
                '@type': 'Question',
                name: '漫画加载慢怎么办？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '韩漫漫画网站采用了优化的CDN加速技术，确保漫画图片的加载速度。我们持续优化服务器性能，为您提供稳定可靠的服务。',
                },
              },
            ],
          }),
        }}
      />

      {/* BreadcrumbList Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.hanmancomic.com/',
              },
            ],
          }),
        }}
      />
    </>
  );
}